export default __webpack_public_path__ + "static/media/mobiCTOInactiveTab.ad3d14f9.svg";